import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PublicationsComponent } from './pages/publications/publications.component';
import { SponsorsComponent } from './pages/sponsors/sponsors.component';
import { DisplayGeneComponent } from './pages/display-gene/display-gene.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { DatasetSelectionComponent } from './pages/dataset-selection/dataset-selection.component';
import { Gwas15Component } from './pages/gwas15/gwas15.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomepageComponent, title: 'GEM•HD | Home' },
  { path: 'gwas-15', component: Gwas15Component, title: 'GEM•HD | GWAS 1-5 Study' },
  { path: 'gwas-16', component: DatasetSelectionComponent, title: 'GEM•HD | GWAS 1-6 Study' },
  {
    path: 'gwas-16/display/:id',
    component: DisplayGeneComponent,
    title: 'GEM•HD | Dataset Explorer',
  },
  {
    path: 'publications',
    component: PublicationsComponent,
    title: 'GEM•HD | Publications',
  },
  {
    path: 'sponsors',
    component: SponsorsComponent,
    title: 'GEM•HD | Sponsors',
  },
  { path: 'about', component: ComingSoonComponent, title: 'GEM•HD | About' },
  {
    path: 'contact',
    component: ComingSoonComponent,
    title: 'GEM•HD | Contact',
  },
  {
    path: 'downloads',
    component: ComingSoonComponent,
    title: 'GEM•HD | Downloads',
  },
  { path: 'help', component: ComingSoonComponent, title: 'GEM•HD | Help' },
  // Legacy route for backward compatibility
  {
    path: 'display/:id',
    redirectTo: 'gwas-16/display/:id',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
